module.exports = __webpack_public_path__ + "static/media/irina_theodoru.0d7547ca.png";